// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__O_ggr","scrollbars":"styles_scrollbars__P3g9_","containerTable":"styles_containerTable__qoOs4","slideInSearchBar":"styles_slideInSearchBar__K5ffz"};